import { useCallback, useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { View } from 'foundations-components/components/View';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useReviewContext } from './ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function ReviewTagsInput({
  disabled,
  fieldKey,
  options,
  onClick,
  label,
  tooltip
}) {
  const {
    getFieldValidation,
    onUpdateReview,
    review
  } = useReviewContext();
  const {
    locked,
    required,
    minSelected,
    maxSelected
  } = getFieldValidation('tags', fieldKey);
  const selectedTags = useMemo(() => review.tags[fieldKey] || [], [fieldKey, review]);
  let validationMessage;
  if (minSelected && review.tags[fieldKey] && review.tags[fieldKey].length !== 0 && review.tags[fieldKey].length < minSelected) {
    validationMessage = unescapedText('trellisEcosystem.reviews.minimumTags', {
      minSelected
    });
  }
  const handleUpdateReview = useCallback(updatedTag => {
    let updatedTags = [...selectedTags];
    if (selectedTags.includes(updatedTag)) {
      updatedTags = updatedTags.filter(tag => tag !== updatedTag);
    } else {
      updatedTags.push(updatedTag);
    }
    onUpdateReview({
      tags: {
        [fieldKey]: updatedTags
      }
    });
  }, [fieldKey, onUpdateReview, selectedTags]);
  return /*#__PURE__*/_jsx(FormControl, {
    error: !!validationMessage,
    label: label,
    required: required,
    tooltip: tooltip,
    validationMessage: validationMessage,
    children: /*#__PURE__*/_jsx(TFlex, {
      direction: "row",
      wrap: "wrap",
      children: options.map(option => /*#__PURE__*/_jsx(View, {
        inlineSize: "auto",
        children: /*#__PURE__*/_jsx(SelectableButton, {
          disabled: disabled || locked || !selectedTags.includes(option.value) && maxSelected && review.tags[fieldKey] && review.tags[fieldKey].length >= maxSelected,
          marginBlockEnd: "200",
          marginInlineEnd: "200",
          marginInlineStart: "0",
          onClick: () => {
            if (onClick) {
              onClick();
            }
            handleUpdateReview(option.value);
          },
          padding: "200",
          selected: selectedTags.includes(option.value),
          size: "xs",
          children: option.text
        })
      }, option.value))
    })
  });
}